import { marcarWsSoporte } from "./estadoWsSoporte";

const MAX_INTENTOS_FALLIDOS = 5;
const MAX_DELAY = 15000;

export const abrirWsSoporte = ({ empresaId, usuarioId }) => {
  const WS_URL =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_WS_SOPORTE_URL_DEV
      : process.env.REACT_APP_WS_SOPORTE_URL_PROD;

  if (!WS_URL) return () => {};

  let socket = null;
  let reconnectDelay = 1000;
  let shouldReconnect = true;
  let intentosFallidos = 0;
  let timer = null;

  const connect = () => {
    socket = new WebSocket(WS_URL);

    socket.onopen = () => {
      reconnectDelay = 1000;
      socket.send(JSON.stringify({ type: "datos", empresaId, usuarioId }));
    };

    socket.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (e) {
        return;
      }

      if (data.success === 2 && data.type === "soporte_ready") {
        intentosFallidos = 0;
        marcarWsSoporte(true);
        return;
      }

      if (data.success === 2 && data.type === "soporte_event") {
        window.dispatchEvent(new CustomEvent("soporte_event", { detail: data }));
      }
    };

    socket.onclose = () => {
      marcarWsSoporte(false);
      intentosFallidos += 1;
      if (intentosFallidos >= MAX_INTENTOS_FALLIDOS) {
        console.warn(`WS Soporte: sin conexión a ${WS_URL}; el chat se actualizará por refresco periódico.`);
        return;
      }
      if (shouldReconnect) {
        timer = setTimeout(connect, reconnectDelay);
        reconnectDelay = Math.min(MAX_DELAY, reconnectDelay * 1.6);
      }
    };
  };

  connect();

  return () => {
    shouldReconnect = false;
    clearTimeout(timer);
    if (socket) socket.close();
    marcarWsSoporte(false);
  };
};

export default abrirWsSoporte;
